import { fragments } from '@/gql'
import gql from 'graphql-tag'
const q = gql`
    query SearcherResult(
      $searcherType: SearcherType,
      $itemType: String!, 
      $limit: Int, 
      $offset: Int, 
      $value: Value, 
      $filters: [Filter],
      $elIncludes: [ElInclude],
      $defaultConfidence: Float,
      $queryType: String,
      $masterLimit: Int
    ) {
      SearcherResult: SearcherResult (
        searcherType: $searcherType, 
        limit: $limit, 
        offset: $offset, 
        value: $value,
        filters: $filters,
        itemType: $itemType,
        elIncludes: $elIncludes,
        defaultConfidence: $defaultConfidence,
        queryType: $queryType
      ) {
        ...searcherResult
      }
    }
    ${fragments.matchDetail}
    ${fragments.searcherResult}
    ${fragments.searchers}
    ${fragments.searchItems}
    ${fragments.matchReason}
    ${fragments.matchIDS}
    ${fragments.matchFilm}
    ${fragments.matchPerson}
    ${fragments.artworkToArtifacts}
    ${fragments.artworkDetails}
    ${fragments.filmDetail}
    ${fragments.filmMasters}
    ${fragments.filmMasterDetail}
    ${fragments.stripDetail}
    ${fragments.filmHost}
    ${fragments.filmMasterPosterFrames}
    ${fragments.filmFiles}
    ${fragments.filmFileDetail}
    ${fragments.personDetail}
    ${fragments.personArtworks}
    ${fragments.matchProfession}
    ${fragments.profession}
    ${fragments.companyDepartmentDetail}
    ${fragments.matchBrand}
    ${fragments.brandDetail}
    ${fragments.brandArtworks}
    ${fragments.matchProduct}
    ${fragments.productDetail}
    ${fragments.productArtworks}
    ${fragments.productCategory}
    ${fragments.productCategoryTree}
    ${fragments.matchCompany}
    ${fragments.matchCompanyType}
    ${fragments.companyArtworks}
    ${fragments.companyType}
    ${fragments.companyTypeTree}
    ${fragments.companyNameDetail}
    ${fragments.companyNames}
    ${fragments.companyDetail}
    ${fragments.matchAward}
    ${fragments.awardDetail}
    ${fragments.awardPrizeDetail},
    ${fragments.awardPrizeArtworks},
    ${fragments.filmAwards}
    ${fragments.awardAncestor}
    ${fragments.personAwards}
  `
export default q
